module.exports = __webpack_public_path__ + "img/popup_main1.4e4674f5.png";